import { PrivacyScreen } from '@capacitor-community/privacy-screen'

import { App } from '@/core/native'

export const enablePrivacyScreen = async () => {
  if (App.getPlatform() === 'web') return

  await PrivacyScreen.enable()
}

export const disablePrivacyScreen = async () => {
  if (App.getPlatform() === 'web') return

  await PrivacyScreen.disable()
}
